import Layout from "../views/layout/Layout";
import config from '../Config'

export default {
    path: '/system',
    component: Layout,
    redirect: '/system/systemConfig',
    meta: {title: '系统管理', icon: 'el-icon-cpu'},
    children: [{
        path: 'systemConfig',
        name: 'systemConfig',
        component: () => import('@/views/system/systemConfig/system-config'),
        meta: {title: '系统配置', icon: 'product-cate'},
        auth: 'system:systemConfig'
    }, {
        path: 'business',
        name: 'business',
        component: () => import('@/views/system/business/index'),
        meta: {title: '业务配置', icon: 'product-cate'},
        auth: 'system:business'
    }, {
        path: 'orderConfig',
        name: 'orderConfig',
        hidden: true,
        component: () => import('@/views/system/orderConfig/index'),
        meta: {title: '订单配置', icon: 'product-cate'},
        auth: 'system:business'
    }, {
        path: 'drawFeeConfig',
        name: 'drawFeeConfig',
        component: () => import('@/views/system/drawFeeConfig/index'),
        meta: {title: '提现手续费配置', icon: 'product-cate'},
        auth: 'system:drawFeeConfig'
    }, {
        path: 'setting',
        name: 'setting',
        component: () => import('@/views/system/setting/index'),
        meta: {title: '设备设置', icon: 'product-cate'},
        auth: 'system:setting'
    }, {
        path: 'advManage',
        name: 'advManage',
        component: () => import('@/views/operation/advManage/index'),
        meta: {title: '广告位管理', icon: 'product-cate'},
        auth: 'operation:advManage'
    }, {
        path: 'personl',
        name: 'personl',
        component: () => import('@/views/system/personl/index'),
        meta: {title: '人员管理', icon: 'product-cate'},
        auth: 'system:personl'
    }, {
        path: 'optionConfig',
        name: 'optionConfig',
        component: () => import('@/views/system/optionConfig/index'),
        meta: {title: '选项配置', icon: 'product-cate'},
        auth: 'system:optionConfig'
    }, {
        path: 'firmwareConfig',
        name: 'firmwareConfig',
        component: () => import('@/views/system/firmwareConfig/index'),
        meta: {title: '固件升级配置', icon: 'product-cate'},
        auth: 'system:firmwareConfig'
    }]
}



// WEBPACK FOOTER //
// ./src/router/system.js